import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    copied: { type: String, default: "복사됨" }
  }

  copy(event) {
    if (!navigator.clipboard) return

    const button = event.currentTarget
    const text = event.params.text
    const successLabel = event.params.successLabel || this.copiedValue
    const originalHtml = button.innerHTML

    navigator.clipboard.writeText(text).then(() => {
      button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>' + successLabel
      button.style.color = "#065F46"
      button.style.borderColor = "#A7F3D0"
      button.style.background = "#ECFDF5"

      setTimeout(() => {
        button.innerHTML = originalHtml
        button.style.color = ""
        button.style.borderColor = ""
        button.style.background = ""
      }, 1500)
    })
  }

  scrollToReply() {
    const form = document.getElementById("reply-form")
    if (form) form.scrollIntoView({ behavior: "smooth" })
  }
}
